import { createSelector } from '@reduxjs/toolkit';
import { CHAT_REDUCER_PATH, type RootState } from 'chat/store';

const baseSelector = (state: RootState) => state[CHAT_REDUCER_PATH].chatWidget;

export const subscriptionStatusSelector = createSelector(
  baseSelector,
  (state) => state.subscriptionStatus,
);

export const unreadMessagesCountSelector = createSelector(
  baseSelector,
  (state) => state.unreadMessagesCount,
);
